'use client';
import { FC } from 'react';

import { Headline } from '@lichtblick/photon/atoms/headline/headline';

import { ErrorBoundary } from './ErrorBoundary';
import { Form } from './Form';
import { COMMODITIES } from './Form.content';
import styles from './LeadForm.module.scss';

import { B2bLeadFormType } from '../../../types';

export const LeadForm: FC<B2bLeadFormType> = ({ commodity, headline }) => (
  <section className={styles.container} id={COMMODITIES[commodity].id}>
    <div className={styles.content}>
      {Boolean(headline) && (
        <Headline align="center" renderAs="h1" size="m">
          {headline}
        </Headline>
      )}
      <div className={styles.box}>
        <ErrorBoundary>
          <Form commodity={commodity} />
        </ErrorBoundary>
      </div>
    </div>
  </section>
);
